<template>
    <button
        v-tippy="t('editorInsertLink')"
        :class="[
            buttonState(
                editor.can().toggleLink({
                    href: 'https://',
                }) &&
                    (editorSelection.text.length > 0 || editor.isActive('link')),
                editor.isActive('link'),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="
            !editor.can().toggleLink({
                href: 'https://',
            }) ||
            (editorSelection.text.length === 0 && !editor.isActive('link'))
        "
        @click="linkInsertModal.state.open = true"
    >
        <MdiLink class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiLink from 'materialdesignicons-vue3/icons/MdiLink.js';

    defineExpose({
        name: 'LinkInsertButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
        editorSelection: {
            type: Object,
            required: true,
        },
        linkInsertModal: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
    const editorSelection = props.editorSelection;
    const linkInsertModal = props.linkInsertModal;
</script>
